import {AxiosResponse} from 'axios'
import httpClient from '@/services/httpClient'
import {
  AxiosRequestFillOrbR,
  AxiosRequestTemplateROrb,
  AxiosRequestTemplateROrbMap,
  FilledOrbInterface,
  ObjectOfMapInterface,
  OrbRInterface,
  TemplatesOrbsRInterface,
  TemplatesOrbsRMapInterface,
} from '@/types/types'
import fileHttpClient from '@/services/fileHttpClient'

const ORB_RESOURCES_PATH = '/collect/orb-resources'

export interface OrbResourcesParams {
  id: string
  hex_id: string
}

const OrbsService = {
  getOrbResources: (params: OrbResourcesParams): Promise<AxiosResponse<any>> =>
    httpClient.get(ORB_RESOURCES_PATH, {params}),
  collectOrbResources: (
    data: OrbResourcesParams
  ): Promise<AxiosResponse<any>> => httpClient.post(ORB_RESOURCES_PATH, data),
  getOrbsR: (): Promise<
    AxiosResponse<{
      inventories: OrbRInterface[]
      filled: FilledOrbInterface[]
      default_octa_coins: number
    }>
  > => httpClient.get(`/all-objects/r-orb`),
  postTemplateOrbR: (data: AxiosRequestTemplateROrb) =>
    httpClient.post('/all-objects/templates/r-orb', data),
  postTemplateOrbRMap: (data: AxiosRequestTemplateROrbMap) =>
    httpClient.post('/all-objects/templates/r-orb-map', data),
  fillOrbR: (data: AxiosRequestFillOrbR) =>
    httpClient.post('/all-objects/r-orb/fill', data),
  // getOrbsR: (): Promise<AxiosResponse<{ templates: TemplatesOrbsRInterface[] }>> =>
  //   httpClient.get(`/all-objects/r-orb`),
  getTemplatesOrbR: (): Promise<
    AxiosResponse<{templates: TemplatesOrbsRInterface[]}>
  > => httpClient.get(`/all-objects/templates/r-orb`),
  getTemplatesOrbRMap: (): Promise<
    AxiosResponse<{templates: TemplatesOrbsRMapInterface[]}>
  > => httpClient.get(`/all-objects/templates/r-orb-map`),
  postFileImage: (
    file: Blob
  ): Promise<AxiosResponse<{status: boolean; filename: string}>> => {
    const data = new FormData()
    data.append('img', file, 'example24.jpeg')
    return fileHttpClient.post(`/add-file/`, data)
  },
  getBatteries: (): Promise<
    AxiosResponse<{orb_batteries: ObjectOfMapInterface[]}>
  > => httpClient.get(`/collect/orb-batteries`),
}

export default OrbsService
